<template>
  <b-tabs
    content-class="mt-3"
    justified
  >
    <b-tab
      :title="tituloAbertos"
      active
    >
      <ListaChatsUsuario
        :chats="chatsAbertos"
        @carregandoChatAtual="$emit('carregandoChatAtual',$event)"
      />
    </b-tab>

    <b-tab
      :title="tituloFechados"
      :disabled="!chatsFechados || chatsFechados.length <= 0"
    >
      <ListaChatsUsuario :chats="chatsFechados" />
    </b-tab>
  </b-tabs>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ListaChatsUsuario from './ListaChatsUsuario.vue';

export default {
  components: {
    ListaChatsUsuario,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(['chatsUsuario']),
    chatsAbertos() {

      return this.chatsUsuario.filter((c) => c.status !== 'ATENDIDO');
    },
    chatsFechados() {
      return this.chatsUsuario.filter((c) => c.status === 'ATENDIDO');
    },
    tituloAbertos() {
      const numerosChats = this.chatsAbertos ? this.chatsAbertos.length : 0;
      return `Open (${numerosChats})`;
    },
    tituloFechados() {
      const numerosChats = this.chatsFechados ? this.chatsFechados.length : 0;
      return `Closed (${numerosChats})`;
    },
  },
  methods: {
    ...mapActions(['definirChatAtual']),
  },
};
</script>

<style lang="scss">
  .mt-3 {
    border-radius: 5px;
  }
  .list-group-item{
    border-radius: 5px;
  }
</style>>
